import { Injectable } from '@angular/core';
import { NewRelicEventsService } from '@services/new-relic-events.service';
import { NEW_RELIC_EVENT, DEVICE, DEVICE_ERROR_CODE } from '@app/enums/new-relic.enum';

@Injectable({ providedIn: 'root' })
export class DeviceMetricsService {
  constructor(private _newRelic: NewRelicEventsService) {}

  connected(device: DEVICE, statusCode?: number): void {
    this._newRelic.trackEvent(NEW_RELIC_EVENT.DEVICE_CONNECTED, { device, statusCode });
  }

  disconnected(device: DEVICE, statusCode?: number): void {
    this._newRelic.trackEvent(NEW_RELIC_EVENT.DEVICE_DISCONNECTED, { device, statusCode });
  }

  error(device: DEVICE, errorCode: DEVICE_ERROR_CODE | string, errorDetail = ''): void {
    this._newRelic.trackEvent(NEW_RELIC_EVENT.DEVICE_ERROR, {
      device,
      errorCode,
      errorDetail,
      isError: true,
    });
  }

  operationTime(device: DEVICE, durationMs: number, success: boolean, errorCode?: string): void {
    this._newRelic.trackEvent(NEW_RELIC_EVENT.DEVICE_OPERATION_TIME, {
      device,
      durationMs,
      success,
      errorCode,
    });
  }
}
